export default __webpack_public_path__ + "static/media/stop.ebb7e21c.mp3";